/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ deltaText: NonNullable<unknown> }} Workout_After_Heavier_DeltaInputs */

const en_us2_workout_after_heavier_delta = /** @type {(inputs: Workout_After_Heavier_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const pt_br2_workout_after_heavier_delta = /** @type {(inputs: Workout_After_Heavier_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const es_419_workout_after_heavier_delta = /** @type {(inputs: Workout_After_Heavier_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const pt_pt2_workout_after_heavier_delta = /** @type {(inputs: Workout_After_Heavier_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const fr_fr2_workout_after_heavier_delta = /** @type {(inputs: Workout_After_Heavier_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const de_de2_workout_after_heavier_delta = /** @type {(inputs: Workout_After_Heavier_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

const it_it2_workout_after_heavier_delta = /** @type {(inputs: Workout_After_Heavier_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText}`)
};

/**
* | output |
* | --- |
* | "{deltaText}" |
*
* @param {Workout_After_Heavier_DeltaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_heavier_delta = /** @type {((inputs: Workout_After_Heavier_DeltaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Heavier_DeltaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_heavier_delta(inputs)
	if (locale === "es-419") return es_419_workout_after_heavier_delta(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_heavier_delta(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_heavier_delta(inputs)
	if (locale === "de-DE") return de_de2_workout_after_heavier_delta(inputs)
	if (locale === "it-IT") return it_it2_workout_after_heavier_delta(inputs)
	return en_us2_workout_after_heavier_delta(inputs)
});
export { workout_after_heavier_delta as "workout-after.heavier_delta" }